import { useState } from 'react';

const BeforeAfterSection = ({ title, pairs, sectionId }) => {
  return (
    <section className="py-16 bg-gray-50 overflow-hidden" data-testid={sectionId}>
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <h2 className="font-heading font-bold text-3xl md:text-4xl mb-12 text-center">
          {title}
        </h2>
        
        <div className="space-y-12">
          {pairs.map((pair, pairIndex) => (
            <div 
              key={pairIndex}
              className={`grid gap-6 md:gap-8 ${
                pair.images.length === 2 
                  ? 'grid-cols-1 md:grid-cols-2' 
                  : 'grid-cols-1 max-w-md mx-auto'
              }`}
            >
              {pair.images.map((image, imgIndex) => (
                <div key={imgIndex} className="relative flex justify-center">
                  <div className="relative w-full max-w-[500px] overflow-hidden bg-gray-100 rounded-sm shadow-md">
                    <img
                      src={image.src}
                      alt={image.alt}
                      loading="lazy"
                      className="w-full h-auto object-cover"
                    />
                    <span className={`absolute top-3 left-3 px-3 py-1 text-xs font-bold uppercase tracking-wider rounded ${
                      image.label === 'Before' || image.label === 'Before cleaning'
                        ? 'bg-red-600 text-white'
                        : 'bg-green-600 text-white'
                    }`}>
                      {image.label}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
